import { BaseTooltip, type BaseTooltipTriggerProps } from "./base-tooltip";

export const PromptCompetitorTooltip = ({ trigger, triggerClassName }: BaseTooltipTriggerProps = {}) => {
      return (
            <BaseTooltip trigger={trigger} triggerClassName={triggerClassName}>
                  <p>Compares the brand with its competitors.</p>
            </BaseTooltip>
      );
};
